import { defineComponent } from 'vue'; // import RecomMend from '@/views/recommend/RecomMend.vue';
// import UserAgreement from '@/views/useragreement/UserAgreement.vue';

export default defineComponent({
  name: 'App'
});